import React from 'react';
import { Row, Col } from 'reactstrap';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DatePicker } from '@progress/kendo-react-dateinputs';

import { AnimalWeightEnum } from '../../animal-enums';
import { UPDATE_WEIGHT, GET_ANIMAL_DETAILS, GET_ANIMAL_ADG } from '../../../../../data/animal/animal-query';
import Mutation from '../../../../../data/mutation';


import './add-weight-modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatesHelper from '../../../../../tools/DatesHelper';

class EditWeightModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      weightToEdit: {
        animalID: props.animalID,
        weightID: props.currentWeight.weightID,
        weightType: props.currentWeight.weightType,
        weight: props.currentWeight.weight,
        dateWeight: DatesHelper.parseDate(props.currentWeight.dateWeight).toDate(),
        comment: props.currentWeight.comment
      }
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setWeightType = this.setWeightType.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openModal() {
    this._resetWeight();
    this.setState({
      visible: true
    });
  }

  closeModal() {
    this.setState({
      visible: false
    });
  }

  handleSubmit(event, mutationTrigger) {
    event.preventDefault();
    const weightToEdit = {
      ...this.state.weightToEdit,
      dateWeight: DatesHelper.dateToApiFormat(this.state.weightToEdit.dateWeight)
    };
    mutationTrigger({
      variables:
        { targetWeight: weightToEdit }
    });
  }

  setWeightType(event) {
    const newWeightType = event.target.dataset.type;
    const weightToEdit = this.state.weightToEdit;
    weightToEdit.weightType = newWeightType;
    this.setState({ weightToEdit });
  }

  _resetWeight() {
    this.setState({
      weightToEdit: {
        animalID: this.props.animalID,
        weightID: this.props.currentWeight.weightID,
        weightType: this.props.currentWeight.weightType,
        weight: this.props.currentWeight.weight,
        dateWeight: DatesHelper.parseDate(this.props.currentWeight.dateWeight).toDate(),
        comment: this.props.currentWeight.comment
      }
    });
  }

  handleFormChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const currentWeightToEdit = { ...this.state.weightToEdit };
    currentWeightToEdit[name] = value;
    this.setState({ weightToEdit: currentWeightToEdit });
  }

  render() {

    return (
      <Mutation mutation={UPDATE_WEIGHT}
        refetchQueries={[
          { query: GET_ANIMAL_ADG, variables: { id: this.props.animalID } },
          { query: GET_ANIMAL_DETAILS, variables: { id: this.props.animalID } }
        ]}
        awaitRefetchQueries={true}
        onCompleted={() => this.closeModal()}
      >
        {(editWeightTrigger) => (
          <div className="d-inline-block">
            <button type="button" className="button-icon" onClick={this.openModal}><FontAwesomeIcon icon={'pen'} /></button>
            {!this.state.visible ? '' :
              <Dialog title={"Добавяне на запис"} minWidth={"500px"} onClose={this.closeModal}>
                <form onSubmit={e => this.handleSubmit(e, editWeightTrigger)}>
                  <Row>
                    <Col lg={{ size: 8, offset: 2 }}>
                      <div className="form-group">
                        <label>Тип</label>
                        <fieldset onChange={e => this.setWeightType(e)}>
                          <input type="radio" id="r1" name="weightType" data-type={AnimalWeightEnum.controlWeight()} className="k-radio" defaultChecked={this.state.weightToEdit.weightType === AnimalWeightEnum.controlWeight()} />
                          <label className="k-radio-label" htmlFor="r1">Контролно тегло</label><br />
                          <input type="radio" id="r2" name="weightType" data-type={AnimalWeightEnum.birthWeight()} className="k-radio" defaultChecked={this.state.weightToEdit.weightType === AnimalWeightEnum.birthWeight()} />
                          <label className="k-radio-label" htmlFor="r2">Тегло при раждане</label><br />
                          <input type="radio" id="r3" name="weightType" data-type={AnimalWeightEnum.weaningWeight()} className="k-radio" defaultChecked={this.state.weightToEdit.weightType === AnimalWeightEnum.weaningWeight()} />
                          <label className="k-radio-label" htmlFor="r3">Тегло при отбиване</label><br />
                          <input type="radio" id="r4" name="weightType" data-type={AnimalWeightEnum.yearlingWeight()} className="k-radio" defaultChecked={this.state.weightToEdit.weightType === AnimalWeightEnum.yearlingWeight()} />
                          <label className="k-radio-label" htmlFor="r4">Тегло на една година</label><br />
                          <input type="radio" id="r5" name="weightType" data-type={AnimalWeightEnum.matureWeight()} className="k-radio" defaultChecked={this.state.weightToEdit.weightType === AnimalWeightEnum.matureWeight()} />
                          <label className="k-radio-label" htmlFor="r5">Тегло на възрастно животно</label><br />
                          <input type="radio" id="r6" name="weightType" data-type={AnimalWeightEnum.techWeight()} className="k-radio" defaultChecked={this.state.weightToEdit.weightType === AnimalWeightEnum.techWeight()} />
                          <label className="k-radio-label" htmlFor="r6">Тегло при клане</label><br />
                        </fieldset>
                      </div>
                      <div className="form-group">
                        <label>Тегло</label>
                        <Input type="number" name="weight" onChange={e => this.handleFormChange(e)} value={this.state.weightToEdit.weight || ''} />
                      </div>
                      <div className="form-group">
                        <label>Дата на претеглянето</label>
                        <DatePicker format="dd.MM.yyyy" value={this.state.weightToEdit.dateWeight} name="dateWeight" onChange={e => this.handleFormChange(e)} />
                      </div>
                      <div className="form-group">
                        <label>Бележка</label>
                        <textarea className="k-textarea" name="comment" onChange={e => this.handleFormChange(e)} value={this.state.weightToEdit.comment} ></textarea>
                      </div>
                      <div className="d-flex">
                        <button type="submit" className="btn btn-success mr-3">Добави</button>
                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Отказ</button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </Dialog>
            }
          </div>
        )}
      </Mutation>
    );
  };
}

export default EditWeightModal;